"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var easyqrcodejs_1 = __importDefault(require("easyqrcodejs"));
var LoginSSI = /** @class */ (function () {
    function LoginSSI(config) {
        this.config = config;
        // test if navigator exists (this tests, if we are in a browser window)
        if (this.config.element && document && window) {
            // render this login
            this.render();
        }
        else if (this.config.element) {
            console.log("unable to render");
        }
    }
    LoginSSI.prototype.render = function (newElement, qrElement) {
        return __awaiter(this, void 0, void 0, function () {
            var element, showQR, qrElement_1;
            var _this = this;
            return __generator(this, function (_a) {
                if (newElement) {
                    this.config.element = newElement;
                }
                if (!this.config.element) {
                    throw Error("Unable to render to null element");
                }
                if (qrElement) {
                    this.config.qrElement = qrElement;
                }
                if (typeof this.config.element === 'string') {
                    element = document.getElementById(this.config.element);
                }
                else {
                    element = this.config.element;
                }
                showQR = true;
                if (navigator) {
                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        // we are on a mobile phone
                        showQR = false;
                    }
                }
                else {
                    throw Error("not a browser to render");
                }
                if (showQR) {
                    // make the QR code     
                    if (!this.config.qr) {
                        this.config.qr = {};
                    }
                    if (!this.config.qr.text) {
                        this.config.qr.text = this.config.verifier + "?redirect=true";
                    }
                    if (element) {
                        if (this.config.qrElement) {
                            if (typeof this.config.qrElement === 'string') {
                                qrElement_1 = document.getElementById(this.config.qrElement);
                            }
                            else {
                                qrElement_1 = this.config.qrElement;
                            }
                            this.qr = LoginSSI.generateQR(qrElement_1, this.config.qr);
                        }
                        else {
                            this.qr = LoginSSI.generateQRModal(element, this.config.qr);
                        }
                    }
                    else {
                        this.qr = LoginSSI.generateQR(element, this.config.qr);
                    }
                }
                else {
                    element.onclick = function () { return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _b = (_a = window).open;
                                return [4 /*yield*/, this.getOpenId()];
                            case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                        }
                    }); }); };
                }
                return [2 /*return*/];
            });
        });
    };
    LoginSSI.prototype.getOpenId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.config.verifier + "?redirect=false")];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.text()];
                }
            });
        });
    };
    LoginSSI.prototype.getQR = function () {
        return this.qr;
    };
    LoginSSI.generateQR = function (element, config) {
        return new easyqrcodejs_1["default"](element, config);
    };
    LoginSSI.generateQRModal = function (element, config) {
        var parent = element.parentElement;
        // create qr container
        var container = document.createElement("div");
        container.style.display = "none";
        parent.append(container);
        // close qr logic
        container.onclick = function () { return container.style.display = "none"; };
        // if user click on button element, show qr code
        element.onclick = function () { return (container.style.display === "block") ? container.style.display = "none" : container.style.display = "block"; };
        // generate and return QRCode
        return LoginSSI.generateQR(container, config);
    };
    return LoginSSI;
}());
exports["default"] = LoginSSI;
//# sourceMappingURL=index.js.map